import { render, staticRenderFns } from "./ConfigurationPriceGroups.vue?vue&type=template&id=7ca0838c&"
import script from "./ConfigurationPriceGroups.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPriceGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports